import PersonalInformation from "./personal-information.container";

export default PersonalInformation;
